var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJazzy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0,0,0)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F3B064",
    d: "M11.827-.451 5.755-3.795a.98.98 0 0 0-1.32 1.35A4.975 4.975 0 0 0 3.143-.624 4.988 4.988 0 0 0 2.784.812l-7.557-9.266a3.39 3.39 0 0 0-4.36-1.689 3.365 3.365 0 0 0-1.832 1.834 3.364 3.364 0 0 0 0 2.591c.146.352.146.739 0 1.091s-.42.625-.771.771a.98.98 0 0 0 .749 1.811 3.36 3.36 0 0 0 1.833-1.832 3.364 3.364 0 0 0 0-2.591 1.414 1.414 0 0 1 0-1.091 1.427 1.427 0 0 1 2.634 0L-.382 7.258c.034.08.069.159.106.237l.036.076a3.94 3.94 0 0 0 .123.241 6.299 6.299 0 0 0 .254.423c.021.033.043.064.065.096l.078.111.072.099.087.112c.029.036.057.072.087.107.042.051.085.101.129.15l.069.075.112.117.061.061c.062.062.126.122.19.18l.031.026c.062.055.124.11.188.162l.007.005c.724.59 1.586 1 2.52 1.186l.022.004a5.224 5.224 0 0 0 .399.064l.078.009c.064.007.127.013.192.018l.02.001c.141.011.283.019.425.019a5.765 5.765 0 0 0 1.816-.297l.132-.043a5.754 5.754 0 0 0 2.72-2.029l.081-.113a5.82 5.82 0 0 0 1.043-3.275l-.001-.141a5.774 5.774 0 0 0-.44-2.114 1.414 1.414 0 0 1 0-1.091c.09-.218.23-.406.407-.552l.155.084a.98.98 0 1 0 .945-1.717z",
    transform: "translate(45.854 54.35)",
    style: {
      display: "block"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJazzy);
export default __webpack_public_path__ + "static/media/jazzy.06c2cbce8b3898f540093e79abc828b5.svg";
export { ForwardRef as ReactComponent };